module.exports = __webpack_public_path__ + "static/media/RestDayCup.e853a29b.svg";